//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
    async fetch() {
        if (!this.banner) {
            await this.$store.dispatch('cms/fetchBannerSecond');
        }
    },
    fetchOnServer: false,
    computed: {
        ...mapGetters({
            banner: 'cms/bannerSecond',
        }),
    },
};
